import styled from 'styled-components';
// Import Global Components
import Button from '../../../../components/Button';

// Styles the form
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => theme.media.tabletPortraitUp`
    input[type="submit"] {
      width: 100%;
    }

    button {
      margin-top: 10px;
    }
  `}
`;

// Contains all inputs in a form
export const InputContainer = styled.fieldset`
  box-sizing: border-box;
  margin-bottom: 45px;

  & > *:not(:last-child) {
    margin-bottom: 15px;
  }
`;

// Outlined secondary action. The shared theme has no outlined button set, so the border and
// text take the brand primary here; `&&` outranks the text variant's transparent border.
// Large size matches the submit button's border, padding and font size, so both are the same height.
export const OutlinedButton = styled(Button).attrs({ size: 'large' })`
  && {
    color: ${({ theme }) => theme.brand.primary};
    border-color: ${({ theme }) => theme.brand.primary};
    border-style: solid;
    background-color: transparent;

    /* A light brand tint keeps the primary-coloured label readable on hover and keyboard focus. */
    &:hover,
    &:focus-visible {
      background-color: ${({ theme }) => theme.brand.primaryLight};
    }
  }
`;
